var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrderNotification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20581_120855)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#4251DA"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_20581_120855)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 14.5547C21.9882 14.5547 21.5 14.5547 23.6 14.5547H27.185C28.1874 14.5547 29 15.3573 29 16.3473V25.2065C29 26.1966 28.1874 26.9991 27.185 26.9991H12.815C11.8126 26.9991 11 26.1966 11 25.2065V16.3473C11 15.3573 11.8126 14.5547 12.815 14.5547H16.4C19 14.5547 18.0118 14.5547 20 14.5547ZM26.9773 16.9133L23.516 19.4592C21.4306 20.993 18.5706 20.9834 16.4959 19.4356L13.1173 16.9151C12.919 16.7672 12.6368 16.806 12.487 17.0019C12.3372 17.1977 12.3765 17.4765 12.5748 17.6244L15.9534 20.1449C18.3473 21.9308 21.6474 21.9419 24.0535 20.1721L27.5148 17.6262C27.7142 17.4796 27.7554 17.2012 27.607 17.0043C27.4585 16.8074 27.1766 16.7667 26.9773 16.9133Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20581_120855"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_20581_120855"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 13,
    fill: "white",
    transform: "translate(11 14)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderNotification);
export default __webpack_public_path__ + "static/media/order-notification.9f5a2314e74ac9d6ee296d96c242976a.svg";
export { ForwardRef as ReactComponent };